/* Comportamiento de los círculos de color.
   Antes iba en línea y se ejecutaba una vez por tarjeta: 16 copias del mismo
   script registrando 16 juegos de listeners sobre los mismos elementos. */
(function(){
    if (window.bmSwatchInit) return;
    window.bmSwatchInit = true;
    var BS = String.fromCharCode(92);
    function bmFixSrcset(){
      var imgs = document.querySelectorAll('img[srcset]');
      for (var n = 0; n < imgs.length; n++) {
        var ss = imgs[n].getAttribute('srcset');
        if (ss && ss.indexOf(BS) !== -1) imgs[n].removeAttribute('srcset');
      }
    }
    if (document.readyState !== 'loading') bmFixSrcset(); else document.addEventListener('DOMContentLoaded', bmFixSrcset);

    function bmCard(el){ return el.closest('.card-wrapper') || el.closest('.card'); }
    function bmImg(card){ return card ? card.querySelector('.card__media img') : null; }

    function bmSelect(card, sw){
      var img = bmImg(card);
      if(img && sw.dataset.img){ img.setAttribute('src', sw.dataset.img); img.setAttribute('srcset',''); card.dataset.bmSel = sw.dataset.img; }
      var href = sw.getAttribute('href');
      /* El botón "Personalizar" (a.quick-add__submit) también debe apuntar al color elegido:
         antes se quedaba con el del primer color y la clienta aterrizaba en otro producto. */
      if(href){ var ls = card.querySelectorAll('a.full-unstyled-link, .card__heading a, a.quick-add__submit[href]'); for(var i=0;i<ls.length;i++){ ls[i].setAttribute('href', href); } }
      /* Precio: el PRO cuesta más que los demás colores; sin esto la tarjeta mentía.
         Dawn pinta TRES nodos de precio: <span class="price-item--regular"> (oculto cuando hay
         oferta), <s class="price-item--regular"> (el tachado) y <span class="price-item--sale">
         (el que se ve). Hay que tocar los tres, y quitar/poner .price--on-sale según el color
         elegido tenga o no precio anterior; si no, quedaba un tachado de otro color. */
      if(sw.dataset.price){
        var pw = card.querySelector('.price');
        if(pw){
          var cmp = sw.dataset.compare || '';
          var setM = function(el, val){
            if(!el) return;
            var conCOP = /COP\s*$/i.test(el.textContent || '');
            el.textContent = val ? (val + (conCOP ? ' COP' : '')) : '';
          };
          setM(pw.querySelector('.price-item--sale'), sw.dataset.price);
          var regs = pw.querySelectorAll('span.price-item--regular');
          for(var z=0; z<regs.length; z++) setM(regs[z], sw.dataset.price);
          setM(pw.querySelector('s.price-item--regular'), cmp);
          pw.classList.toggle('price--on-sale', !!cmp);
          if(!pw.querySelector('.price-item--sale') && regs.length === 0){ setM(pw.querySelector('.price-item'), sw.dataset.price); }
        }
      }
      if(sw.dataset.title){ var hs = card.querySelectorAll('.card__heading a'); for(var k=0;k<hs.length;k++){ hs[k].textContent = sw.dataset.title; } }
      if(sw.dataset.variant){ var qa = card.querySelectorAll('.quick-add [name="id"], product-form input[name="id"]'); for(var q=0;q<qa.length;q++){ qa[q].value = sw.dataset.variant; } var pu = card.querySelectorAll('[data-product-url]'); for(var p=0;p<pu.length;p++){ if(href) pu[p].setAttribute('data-product-url', href); } }
      var all = card.querySelectorAll('.bm-swatch'); for(var j=0;j<all.length;j++){ all[j].classList.remove('is-on'); }
      sw.classList.add('is-on');
    }

    // CLIC en el swatch. Primero por el elemento (camino normal y fiable); si algo lo tapa
    // (la capa-link de la tarjeta o la barra "Draft" del preview) se cae al respaldo por
    // posición, PERO acotado a la tarjeta donde ocurrió el clic — nunca a toda la página,
    // para no cancelar clics de botones flotantes que no tienen nada que ver.
    document.addEventListener('click', function(e){
      if (!e.target || !e.target.closest) return;
      var sw = e.target.closest('.bm-swatches--card .bm-swatch');
      if (!sw) {
        var host = bmCard(e.target);
        if (host) {
          var sws = host.querySelectorAll('.bm-swatches--card .bm-swatch');
          for (var i = 0; i < sws.length; i++) {
            var r = sws[i].getBoundingClientRect();
            if (r.width && e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) { sw = sws[i]; break; }
          }
        }
      }
      if (!sw) return;
      e.preventDefault(); e.stopPropagation();
      /* v57 — un color AGOTADO no se selecciona. En v56 sí lo hacía y era una trampa: en la
         tarjeta del Classic Black, tocar el círculo beige (agotado, $239.700) dejaba la tarjeta
         mostrando ese precio más barato CON el botón encendido; al tocar "Agregar al carrito"
         Shopify devolvía 422 y la tarjeta del Black —que sí estaba disponible— se quedaba en
         "Agotado" hasta recargar. Ahora el círculo tachado solo muestra la foto al pasar por
         encima; no cambia precio, ni nombre, ni la variante del formulario. */
      /* v115: un color en lanzamiento («Pronto») tampoco se selecciona: aún no se vende. */
      if (sw.classList.contains('bm-swatch--out') || sw.classList.contains('bm-swatch--pronto')) return;
      var card = bmCard(sw); if (card) bmSelect(card, sw);
    }, true);

    // HOVER (cuando el swatch no está tapado): previsualiza; al salir vuelve al color elegido.
    document.addEventListener('mouseover', function(e){
      var sw = e.target.closest ? e.target.closest('.bm-swatches--card .bm-swatch[data-img]') : null; if(!sw) return;
      var card = bmCard(sw); var img = bmImg(card); if(!img) return;
      if(!img.dataset.bmOrig){ img.dataset.bmOrig = img.getAttribute('src'); }
      img.setAttribute('src', sw.dataset.img); img.setAttribute('srcset','');
    });
    document.addEventListener('mouseout', function(e){
      var sw = e.target.closest ? e.target.closest('.bm-swatches--card .bm-swatch[data-img]') : null; if(!sw) return;
      var card = bmCard(sw); var img = bmImg(card); if(!img) return;
      var restore = card.dataset.bmSel || img.dataset.bmOrig;
      if(restore){ img.setAttribute('src', restore); img.setAttribute('srcset',''); }
    });
  })();

/* v115 — insignia «Llega el 27 sep» de las tarjetas (snippets/bm-lanzamiento-card.liquid): si la
   página vino de caché y la hora del lanzamiento ya pasó, vuelve a decir «Agotado». */
(function(){
  function lzCards(){
    var l = document.querySelectorAll('[data-bm-lz-card]');
    for (var i = 0; i < l.length; i++) {
      var h = parseInt(l[i].getAttribute('data-hasta'), 10) || 0;
      if (h && Date.now() >= h) l[i].textContent = l[i].getAttribute('data-agotado');
    }
  }
  if (document.readyState !== 'loading') lzCards(); else document.addEventListener('DOMContentLoaded', lzCards);
})();
